import { externalPointAward, nullAward, pointAward, pointsPerAward, AwardType } from './awardTypes';

import { EarningMechanismKeys } from '../redux';

export type EarningMechanismType = {
  id: EarningMechanismKeys;
  title: string;
  exampleCopy: string;
  awardTypes: AwardType[];
};

// Old comma Bad
export const perGroupPurchased: EarningMechanismType = {
  id: 'perGroupPurchased',
  title: 'Per Group Purchased',
  exampleCopy: 'Earn 15 points for every 2 Cokes or Buy 2 Fritos and 1 Gatorade and get 150 points',
  awardTypes: [pointAward],
};

export const perItemPurchased: EarningMechanismType = {
  id: 'perItemPurchased',
  title: 'Per Item Purchased',
  exampleCopy: 'Earn 1 point per $1 spent or Earn 2 points per item purchased',
  awardTypes: [pointsPerAward],
};

export const perItemsAccumulated: EarningMechanismType = {
  id: 'perItemsAccumulated',
  title: 'Per Items Accumulated',
  exampleCopy: 'Buy 40 gallons of gas and earn 200 points',
  awardTypes: [pointAward],
};

export const perTaggedGroupPurchased: EarningMechanismType = {
  id: 'perTaggedGroupPurchased',
  title: 'Per Group Purchased',
  exampleCopy: 'Earn 15 points for every 2 Cokes or Buy 2 Fritos and 1 Gatorade and get 150 points',
  awardTypes: [pointAward],
};

export const perTaggedItemPurchased: EarningMechanismType = {
  id: 'perTaggedItemPurchased',
  title: 'Per Item Purchased',
  exampleCopy: 'Earn 1 point per $1 spent or Earn 2 points per item purchased',
  awardTypes: [pointsPerAward],
};

export const perTaggedItemsAccumulated: EarningMechanismType = {
  id: 'perTaggedItemsAccumulated',
  title: 'Per Items Accumulated',
  exampleCopy: 'Buy 40 gallons of gas and earn 200 points',
  awardTypes: [pointAward],
};

// Transaction-Based
export const totalEligiblePurchase: EarningMechanismType = {
  id: 'totalEligiblePurchase',
  title: 'Total Eligible Purchase',
  exampleCopy: 'Earn 2 points per $1 spent or Earn 1 point per item purchased on every transaction',
  awardTypes: [pointsPerAward],
};

export const totalSpendOnTransaction: EarningMechanismType = {
  id: 'totalSpendOnTransaction',
  title: 'Total Spend On Transaction',
  exampleCopy:
    'Earn 1 point for every dollar spent (excluding tobacco products) on every transaction',
  awardTypes: [pointsPerAward],
};

export const totalEligiblePurchaseOverTime: EarningMechanismType = {
  id: 'totalEligiblePurchaseOverTime',
  title: 'Total Eligible Purchase Over Time',
  exampleCopy: 'Buy 40 gallons of gas this month and earn 200 points',
  awardTypes: [pointAward],
};

export const totalSpendOverTime: EarningMechanismType = {
  id: 'totalSpendOverTime',
  title: 'Total Spend Over Time',
  exampleCopy: 'Earn 50 points for every $50 spent except tobacco products',
  awardTypes: [pointAward],
};

export const productPurchase: EarningMechanismType = {
  id: 'productPurchase',
  title: 'Product Purchase',
  exampleCopy: 'Earn 2 points per item purchased on every transaction',
  awardTypes: [pointAward],
};

export const varietyPurchase: EarningMechanismType = {
  id: 'varietyPurchase',
  title: 'Variety Purchase',
  exampleCopy: 'Buy 2 Fritos, 1 Gatorade and get 150 points on every transaction',
  awardTypes: [pointAward],
};

export const varietyPurchaseOverTime: EarningMechanismType = {
  id: 'varietyPurchaseOverTime',
  title: 'Variety Purchase Over Time',
  exampleCopy:
    'Buy 1 fountain drink, 1 coffee, and 1 hot dog over the course of this week to earn 150 points.',
  awardTypes: [pointAward],
};

export const externalFulfillment: EarningMechanismType = {
  id: 'externalFulfillment',
  title: 'External Fulfillment',
  exampleCopy: 'Buy one Coke & get one Free or Earn 25 points per externally-fulfilled Frito',
  awardTypes: [pointAward, nullAward],
};

export const loyaltyEvent: EarningMechanismType = {
  id: 'loyaltyEvent',
  title: 'Loyalty Event',
  exampleCopy: 'Spin the wheel to get points or Earn 50 points for completing your profile',
  awardTypes: [externalPointAward, pointAward],
};

export const membershipEvent: EarningMechanismType = {
  id: 'membershipEvent',
  title: 'Membership Event',
  exampleCopy: 'Earn 100 points for confirming your membership or Earn 25 points on your birthday',
  awardTypes: [pointAward],
};

export const visits: EarningMechanismType = {
  id: 'visits',
  title: 'Visits',
  exampleCopy: 'Visit 10 times and earn 500 points',
  awardTypes: [pointAward],
};

export const earningMechanismTypes = {
  externalFulfillment,
  loyaltyEvent,
  membershipEvent,
  perGroupPurchased,
  perItemPurchased,
  perItemsAccumulated,
  perTaggedGroupPurchased,
  perTaggedItemPurchased,
  perTaggedItemsAccumulated,
  productPurchase,
  totalEligiblePurchase,
  totalEligiblePurchaseOverTime,
  totalSpendOnTransaction,
  totalSpendOverTime,
  varietyPurchase,
  varietyPurchaseOverTime,
  visits,
};
